import { connect } from 'react-redux'
import TableDriversPane from '../../components/drivers/TableDriversPane'
import { actionCreators } from '../../state/actions/drivers'
import { IDriverFilters, IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    currentOrgId: state.organizations.currentOrgId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    updateDriverFilters: (params: IDriverFilters) => dispatch(actionCreators.updateDriverFilters(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableDriversPane)



// WEBPACK FOOTER //
// ./src/containers/drivers/TableDriversPane.ts